import React from 'react';
import FacebookIcon from 'common/assets/icons/common/social-media/facebook.svg';
import InstagramIcon from 'common/assets/icons/common/social-media/instagram.svg';
import TelegramIcon from 'common/assets/icons/common/social-media/telegram.svg';
import MediumIcon from 'common/assets/icons/common/social-media/medium.svg';
import { withTranslation } from 'react-i18next';
import * as S from './styled';

const LINKS = [
  'https://affiliate.rock-west.com/visit/?bta=35071&nci=5442&utm_campaign=FbRWT',
  'https://affiliate.rock-west.com/visit/?bta=35071&nci=5352&utm_campaign=Instagram',
  'https://affiliate.rock-west.com/visit/?bta=35071&nci=5444&utm_campaign=TG_RWT',
  'https://affiliate.rock-west.com/visit/?bta=35071&nci=5443&utm_campaign=MedRWT',
];

const IMG = [FacebookIcon, InstagramIcon, TelegramIcon, MediumIcon];

export default withTranslation()(({ t }) => (
  <S.MainContainer>
    <S.Header>{t('common.followUs')}</S.Header>
    <S.Container>
      {LINKS.map((icon, i) => (
        <S.SocialMediaIcon key={i}>
          <a target="_blank" rel="noopener noreferrer" href={LINKS[i]}>
            <img src={IMG[i]} width="24" draggable="false" alt="" />
          </a>
        </S.SocialMediaIcon>
      ))}
    </S.Container>
  </S.MainContainer>
));
